<template>
	<div>
		<el-card class="cwscheme">
		<div v-for="tab in tabs">
			<el-row>
				<el-col :span="20">
					<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
					<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
				</el-col>
				<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
			</el-row>
			<el-row style="height:10px;"></el-row>
			<el-row>
				<el-col :span="24">
					<tableui
						style="width:100%;"
						v-loading="loading"
						ref="schemelist"
						editcell="0"
						:tableData="schemelist"
						:columns="tab.columns"
						@gridhandle="gridhandle"
						:gridheight="gridheight"
						@gridsort="gridsort"
						@checkboxchange="checkboxchange"
					></tableui>
				</el-col>
			</el-row>
		</div>
		<div>
			<el-row>
				<el-col :span="12">
					<span>共 {{count}} 条数据</span>
			    </el-col>
			</el-row>
		</div>
		<el-dialog
			:visible.sync="showvipwin"
			title="财务方案增减人员"
			width="50%"
			:close-on-click-modal="false"
			lock-scroll
			append-to-body
			:show-close="true"
		>
		<selectvip ref="userwin"></selectvip>
		</el-dialog>
		</el-card>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import selectvip from '@/components/vip/selectvip.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		handlerbutton,
		selectvip
	},
	data() {
		return {
			columns: [],
			schemelist: [],
			count: 0,
			pagecount: 1,
			gridheight: (window.innerHeight * 72) / 100 + 'px',
			loading: false,
			showvipwin:false,
			c_id:'',
			loading: false,
			pageindex: 0,
			pagesize: 0,
			search: '',
			sort: '',
			activeTabIndex:0,
			tabs:[],
			mode:'财务方案',
			searchbox:'',
			checkedrow:[],
			selectedall:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/cw/cwscheme.scss');
			this.getTabs();
		});
		var that=this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
	},
	methods: {
		getTabs() {
			this.$apipost.get.GetTabs({ parentid: 83 }).then(res => {
				this.tabs = res.tabs;
				console.log('cwscheme-tabs',this.tabs);
				this.GetTabData();
			});
		},
		//获取表头方法
		GetTabData() {
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.schemelist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				this.loading = true;
				var paraminfo={
						mode:this.mode,
						tab:this.tabs[this.activeTabIndex].type,
						search: this.GetSearchObj(),
						pageindex: this.pageindex,
						pagesize: this.pagesize,
						sort: this.sort,
						iscount:1,
						showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns)
					}
				this.$apipost.get
					.GetGridTable({paraminfo:paraminfo})
					.then(res => {
						that.loading = false;
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.schemelist.push(res.data);
							} else {
								that.schemelist = res.data;
							}
						}
						this.count=res.count;
						that.tabs[this.activeTabIndex].pagecount = res.pagecount;
					});
			}
		},
		GetSearchObj(){
			var searchinfo={
				searchbox:this.searchbox
			}
			return searchinfo;
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'addscheme') {
				this.addscheme(e);
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			if (e.event == 'editscheme') {
				this.editscheme(e);
			}
			if (e.event == 'delscheme') {
				this.delscheme(e);
			}
			if (e.event == 'setuser') {
				this.setuser(e);
			}
		},
		//添加角色
		addscheme(e) {
			Utils.$emit('go',{l_url:'/cw/setscheme',l_name:'新增方案',l_id:e.l_id,urlparam:{}});
		},
		//编辑角色
		editscheme(e) {
			Utils.$emit('go',{l_url:'/cw/setscheme',l_name:'修改方案',l_id:e.l_id,urlparam:{c_id:escape(this.schemelist[e.index].c_id)}});		
		},	
		//用户增减人员
		setuser(e){
			//弹窗选择人员
			var that=this;
			this.showvipwin=true;
			this.$nextTick(function(){
				if(that.$refs.userwin!=undefined){
					//debugger
					that.$refs.userwin.init({ c_id: that.schemelist[e.index].c_id,p_mode:that.schemelist[e.index].p_mode,p_type:that.schemelist[e.index].p_type});
				}
			});
			
			// else{
			// 	this.c_id=this.schemelist[e.index].c_id;
			// }
		},
		delscheme(e){
			var that = this;
			this.$confirm('确定删除此方案吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal:false
			})
				.then(() => {
					this.$apipost.post.Delscheme({ c_id: that.schemelist[e.index].c_id }).then(res => {
						if (res.state == '1') {
							this.$tool.message('删除成功', 1);
							that.refreshgrid(true);
						} else {
							this.$tool.message(res.message, 0);
						}
					});
				})
				.catch(() => {});
		}
	}
};
</script>
